<div fxLayout="row" mat-dialog-title>
    <div fxFlex>
        <h2 mat-dialog-title>Gestion des codes</h2>
    </div>
    <div fxFlex="80px">
        <button mat-icon-button (click)="addCode()"><fa-icon [icon]="['fas','plus-circle']" size="2x"></fa-icon></button>
    </div>
</div>
<mat-dialog-content class="codes-table">
    <div fxLayout="row">
        <div fxFlex="120px">
            <form class="example-form">
                <mat-form-field class="field-full-width">
                    <input type="text"
                            placeholder="Chercher un code"
                            aria-label="code"
                            matInput
                            [formControl]="codeSearchControl">
                </mat-form-field>
            </form>
            <div class="codes-table-container">
                <table mat-table matSort [dataSource]="codes">
                    <ng-container matColumnDef="code">
                        <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
                        <td mat-cell *matCellDef="let code" class="fakelink" (click)="selectCode(code)">
                            {{ code.value }}
                        </td>
                    </ng-container>
                    <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>        
            </div>
        </div>
        <div fxFlex>
            <app-admin-service-code [code]="code"></app-admin-service-code>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>